export default __webpack_public_path__ + "static/media/Singapura Finance Limited.275f11f4.png";